module.exports = __webpack_public_path__ + "static/media/edit.3363eee3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/edit.svg
// module id = 271
// module chunks = 0